import Rollbar from 'rollbar';

let rollbarLib;

export function init({ accessToken, environment, endpoint, appId, errorLoggingEnabled, nodeEnv }) {
    if (!rollbarLib) {
        rollbarLib = new Rollbar({
            accessToken,
            captureUncaught: true,
            captureUnhandledRejections: true,
            environment,
            endpoint,
            enabled: errorLoggingEnabled && nodeEnv !== 'test',
            payload: {
                appId,
            },
        });

        window.onunhandledrejection = function (e) {
            rollbarLib.error(e.reason);
        };
    }

    return rollbarLib;
}

export function client() {
    return rollbarLib;
}

export function get(key) {
    if (!rollbarLib) {
        return null;
    }

    return rollbarLib.options.payload[key];
}
